import React, { useState } from 'react'
import EmailContactSubmitMessage from '../../../EmailContactForm/EmailContactSubmitMessage.jsx'
import EmailContactForm from '../../../EmailContactForm/EmailContactForm.jsx'
import { AskSpecialistEmailRecipient } from '../../../EmailContactForm/Data/EmailContactDataSource.js'

export default function AskSpecialist() {
  const searchArray =
    window.location.search && window.location.search.split('=')
  const serviceType = searchArray.length > 1 && searchArray[1]

  const service =
    AskSpecialistEmailRecipient[serviceType] || AskSpecialistEmailRecipient.aqa

  const [isSubmitted, setIsSubmitted] = useState(false)

  const [isError, setIsError] = useState(false)

  const onSubmitted = () => {
    setIsSubmitted(true)
  }

  const showError = () => {
    setIsError(true)
  }

  return (
    <div className="u-adel-reset">
      <div>
        {isSubmitted ? (
          <EmailContactSubmitMessage
            serviceType={serviceType}
            service={service}
            isError={isError}
          />
        ) : (
          <EmailContactForm
            service={service}
            onSubmitted={onSubmitted}
            showError={showError}
          />
        )}
      </div>
    </div>
  )
}
